module.exports = __webpack_public_path__ + "img/three-seven-days.2351a32.svg";